/* eslint-disable key-spacing */
/* eslint-disable no-multi-spaces */
import { parseNumber } from '@utils/numberConversions'

export const buildLiability = (liability, liabilityType) => {
  const date          = new Date()
  const builtLiability   = {
    liability_type:        liabilityType,
    name:                  liability.name || 'No name',
    created_at:            date,
    updated_at:            date,
    price_date:            date,
    value:                 parseNumber(liability.value) || 0,
    monthly_repayment:     parseNumber(liability.monthly_repayment) || 0,
    term_of_debt:          parseNumber(liability.term_of_debt) || 0,
    interest_rate:         liability.interest_rate
  }

  return builtLiability
}
